import React, { useEffect } from 'react'
import { FormContext, useForm } from 'react-hook-form'
import { Card, CardActions, CardContent, FontIcon, Grid } from 'react-md'

import { handleSubmit, Input, InputNumber } from 'components/form'
import { Cell, PageTitle, ButtonSuccess } from 'components/core'

import { defaultValues, validationSchema } from './config'
import { handleSave } from './actions'

const Component: React.FC = () => {
  const form = useForm({ defaultValues })

  useEffect(() => {
    document.title = 'Nova Peça'
  }, [])

  return (
    <Grid>
      <Cell>
        <PageTitle title='Nova Peça' />
        <Card fullWidth>
          <CardContent>
            <FormContext {...form}>
              <Grid>
                <Input name='name' label='Nome *' desktopSize={3} tabletSize={4} />
                <Input name='code' label='Código/Part Number *' desktopSize={2} tabletSize={4} />
                <Input name='manufacturerCode' label='Código do Fabricante *' desktopSize={2} tabletSize={4} />
                <Input name='manufacturerName' label='Nome do Fabricante *' desktopSize={3} tabletSize={4} />
                <Input name='address' label='Endereço' desktopSize={2} tabletSize={4} />
                <InputNumber name='quantity' label='Quantidade *' desktopSize={2} tabletSize={4} />
                <Input name='equipmentModels' label='Modelos de Equipamento *' desktopSize={10} tabletSize={4} />
              </Grid>
            </FormContext>
          </CardContent>
          <CardActions>
            <ButtonSuccess
              text='Salvar'
              icon={<FontIcon>done</FontIcon>}
              disabled={!form.formState.dirty}
              onClick={async () =>
                await handleSubmit(form, validationSchema, async () => {
                  if (await handleSave(form.getValues())) form.reset(defaultValues, { dirty: false })
                })
              }
            />
          </CardActions>
        </Card>
      </Cell>
    </Grid>
  )
}

export default Component
